import React from 'react';

const Tag = ({ children }) => <div className="ws-ui-tag-input-tag">{children}</div>;

export default Tag;
